import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&.locationAccordion': {
    boxShadow: 'none',
    backgroundColor: 'none',
    backgroundImage: 'unset',

    '& .LAsummary': {
      padding: 0,

      '&.Mui-expanded': {
        minHeight: theme.spacing(4.75),
      },

      '& .MuiAccordionSummary-content': {
        margin: theme.spacing(0, 0, 1, 0),
        '&.Mui-expanded': {
          margin: theme.spacing(0, 0, 1, 0),
        },
      },
    },
    '& .childLocation': {
      color: theme.palette.text.secondary,
    },
  },
}));
export default StyledAccordion;
